module.exports = {"321181001":"云阳街道","321181002":"曲阿街道","321181100":"司徒镇","321181101":"延陵镇","321181102":"珥陵镇","321181103":"导墅镇","321181104":"皇塘镇","321181105":"吕城镇","321181106":"陵口镇","321181107":"访仙镇","321181108":"界牌镇","321181113":"丹北镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321181.json
// module id = 1025
// module chunks = 0